import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import type { IntegrationCrmType } from "common/types";

type SourceType = "campaigns" | "lists";

async function getCrmSourcesRequest(
  workspaceId: string,
  crmType: IntegrationCrmType,
  sourceType: SourceType,
): Promise<{ id: string; name: string }[]> {
  return (
    await get(`workspaces/${workspaceId}/integrations/${crmType}/${sourceType}`)
  )[sourceType];
}

export default function useCrmSources({
  crmType,
  sourceType,
}: {
  crmType: IntegrationCrmType;
  sourceType: SourceType;
}) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data: crmSources, isLoading: iseLoadingCrmSources } = useQuery({
    queryKey: [workspaceId, "crmSources", crmType, sourceType],
    queryFn: () => getCrmSourcesRequest(workspaceId, crmType, sourceType),
  });

  return {
    crmSources,
    iseLoadingCrmSources,
  };
}
